import { EluveError, EluveErrorArgs } from './eluve-error';
import { LogLevel } from './types';

export class EncounterNotFoundError extends EluveError {
  static override readonly errorName = 'EncounterNotFoundError';
  readonly logLevel: LogLevel = 'info';

  constructor(message = 'No encounter found', args?: EluveErrorArgs) {
    super(message, args);
  }
}
